"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(ele) {
  var element = global.jQuery(ele);
  element.attr('temp', element.attr('title'));
  element.attr('title', element.data('title'));
  element.tooltip('show');
  setTimeout(function () {
    element.tooltip('hide');
    element.attr('title', element.attr('temp'));
  }, 2000);
};